import type { MailboxInfo } from "owa-client-types";
import { createStore } from "owa-satcheljs";

const defaultExport: () => {
    userMailboxInfoMap: Map<string, MailboxInfo>;
} = createStore("OWAClientIdStore", {
    userMailboxInfoMap: new Map<string, MailboxInfo>(),
});
export default defaultExport;
